export const isVoid = obj => {
    return obj === undefined || obj === null;
};
